import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { uiSlice } from './slices/uiSlice';
import { locationSlice } from './slices/locationSlice';
import { storesSlice } from './slices/storesSlice';
import { storesApi } from './services/stores';
import { customWorkTimesApi } from './services/customWorkTimes';
import { resellersApi } from './services/resellers';
export const store = configureStore({
    reducer: {
        ui: uiSlice.reducer,
        location: locationSlice.reducer,
        stores: storesSlice.reducer,
        [storesApi.reducerPath]: storesApi.reducer,
        [resellersApi.reducerPath]: resellersApi.reducer,
        [customWorkTimesApi.reducerPath]: customWorkTimesApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .concat(storesApi.middleware)
        .concat(resellersApi.middleware)
        .concat(customWorkTimesApi.middleware),
});
setupListeners(store.dispatch);
